// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import flatpickr from "flatpickr"
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate"

// Phoenix theme scripts rely on full page loads; keep Turbo Streams but disable Turbo Drive navigation.
Turbo.session.drive = false

function bindQuickViewLinks() {
  var links = document.querySelectorAll("[data-quick-view-frame]");
  if (!links.length) return;

  links.forEach(function(link) {
    if (link.dataset.quickViewBound === "true") return;
    link.dataset.quickViewBound = "true";

    link.addEventListener("click", function(event) {
      var frameId = link.dataset.quickViewFrame;
      if (!frameId) return;
      event.preventDefault();
      Turbo.visit(link.href, { frame: frameId });
    });
  });
}

document.addEventListener("DOMContentLoaded", bindQuickViewLinks);
document.addEventListener("turbo:load", bindQuickViewLinks);

function bindDangerConfirmations() {
  var buttons = document.querySelectorAll("[data-confirm-message]");
  if (!buttons.length) return;

  buttons.forEach(function(button) {
    if (button.dataset.confirmBound === "true") return;
    button.dataset.confirmBound = "true";

    button.addEventListener("click", function(event) {
      var message = button.dataset.confirmMessage;
      if (!message) return;
      if (!window.confirm(message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", bindDangerConfirmations);
document.addEventListener("turbo:load", bindDangerConfirmations);

function bindTypedDeleteConfirmations() {
  var inputs = document.querySelectorAll("[data-delete-confirm-input]");
  if (!inputs.length) return;

  inputs.forEach(function(input) {
    if (input.dataset.deleteConfirmBound === "true") return;
    input.dataset.deleteConfirmBound = "true";

    var targetSelector = input.dataset.deleteConfirmTarget;
    var expectedValue = input.dataset.deleteConfirmValue || "";
    var target = targetSelector ? document.querySelector(targetSelector) : null;
    if (!target) return;

    var updateState = function() {
      var matches = input.value.trim() === expectedValue;
      target.disabled = !matches;
    };

    input.addEventListener("input", updateState);

    var modal = input.closest(".modal");
    if (modal) {
      modal.addEventListener("shown.bs.modal", function() {
        input.value = "";
        updateState();
        input.focus();
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", bindTypedDeleteConfirmations);
document.addEventListener("turbo:load", bindTypedDeleteConfirmations);

function bindLoadingProgress() {
  var forms = document.querySelectorAll("form");
  if (!forms.length) return;

  forms.forEach(function(form) {
    if (form.dataset.loadingProgressBound === "true") return;
    form.dataset.loadingProgressBound = "true";

    form.addEventListener("submit", function() {
      var progress = form.querySelector("[data-loading-progress]");
      var submit = form.querySelector("[data-loading-submit]");
      if (progress) progress.classList.remove("d-none");
      if (submit) submit.setAttribute("disabled", "disabled");
    });
  });
}

document.addEventListener("DOMContentLoaded", bindLoadingProgress);
document.addEventListener("turbo:load", bindLoadingProgress);

function bindFlatpickr() {
  var inputs = document.querySelectorAll("[data-flatpickr]");
  if (!inputs.length) return;

  inputs.forEach(function(input) {
    if (input.dataset.flatpickrBound === "true") return;
    input.dataset.flatpickrBound = "true";

    if (input._flatpickr) {
      input._flatpickr.destroy();
      input._flatpickr = null;
    }

    var mode = input.dataset.flatpickr || "date";
    var options = {
      dateFormat: "Y-m-d",
      allowInput: true,
      disableMobile: true,
      appendTo: document.body,
      positionElement: input,
      inline: false,
      static: false,
      clickOpens: true,
      position: "auto",
      plugins: [confirmDatePlugin({ showAlways: true, confirmText: "Confirm" })],
      onReady: function(_, __, instance) {
        instance.close();
        input.addEventListener("focus", function() {
          instance.open();
        });
        input.addEventListener("click", function() {
          instance.open();
        });
      },
      onOpen: function(_, __, instance) {
        instance.redraw();
        if (typeof instance.positionCalendar === "function") {
          instance.positionCalendar();
        }
      }
    };

    if (mode === "datetime") {
      options.enableTime = true;
      options.time_24hr = true;
      options.dateFormat = "Y-m-d H:i";
    } else if (mode === "range") {
      options.mode = "range";
      options.dateFormat = "Y-m-d";
    }

    input._flatpickr = flatpickr(input, options);
  });
}

document.addEventListener("DOMContentLoaded", bindFlatpickr);
document.addEventListener("turbo:load", bindFlatpickr);

function bindDataGeneratorStatusPoller() {
  var cards = document.querySelectorAll("[data-data-generator-status]");
  if (!cards.length) return;

  cards.forEach(function(card) {
    if (card.dataset.statusBound === "true") return;
    card.dataset.statusBound = "true";

    var url = card.dataset.statusUrl;
    if (!url) return;

    var label = card.querySelector("[data-status-label]");
    var spinner = card.querySelector("[data-status-spinner]");
    var lastRun = card.querySelector("[data-status-last-run]");
    var updateUI = function(payload) {
      var status = payload && payload.status ? payload.status : "idle";
      var completedAt = payload && payload.completed_at ? payload.completed_at : null;

      if (spinner) spinner.classList.toggle("d-none", status !== "running");

      if (label) {
        if (status === "running") label.textContent = "Running";
        else if (status === "failed") label.textContent = "Failed";
        else if (status === "completed") label.textContent = "Complete";
        else label.textContent = "Idle";

        label.classList.toggle("text-danger", status === "failed");
        label.classList.toggle("text-success", status === "completed");
        label.classList.toggle("text-body-tertiary", status === "idle");
      }

      if (lastRun) {
        lastRun.textContent = completedAt ? "Last run: " + completedAt : "Last run: -";
      }
    };

    var fetchStatus = function() {
      fetch(url, { headers: { "Accept": "application/json" } })
        .then(function(response) { return response.json(); })
        .then(function(payload) { updateUI(payload); });
    };

    fetchStatus();
    window.setInterval(fetchStatus, 10000);
  });
}

document.addEventListener("DOMContentLoaded", bindDataGeneratorStatusPoller);
document.addEventListener("turbo:load", bindDataGeneratorStatusPoller);
